import { render, staticRenderFns } from "./shape.vue?vue&type=template&id=f0e20258&"
import script from "./shape.vue?vue&type=script&lang=js&"
export * from "./shape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports